import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const SeniorBoard = () => {
    useEffect(() => {
        document.title = 'Senior Board -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  About Us</li>
                <li>Prefectorial Board</li>
                 <li>Senior Board</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Senior School </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                <h6>Student Council 2026-27</h6>
                <div className="table-responsive maintable">
                <table className="table">
                   <thead>
                          <tr> 
                          <th> Sl No</th>
                           <th> POST</th>
                           <th>NAME OF THE STUDENT </th>
                           <th>CLASS & SECTION</th>
                         </tr>
                   </thead>
                   <tbody> 
                   <tr><td>1</td><td>CAPTAIN - ARJAN HOUSE</td><td>ISHYA MEHRA</td><td>11 E</td></tr>
    <tr><td>2</td><td>VICE CAPTAIN – ARJAN HOUSE</td><td>VANSHIKA SINGH</td><td>11 E</td></tr>
    <tr><td>3</td><td>PREFECT – ARJAN HOUSE</td><td>THEA SOLANKI</td><td>11 E</td></tr>
    <tr><td>4</td><td>PREFECT – ARJAN HOUSE</td><td>ABHINAV UPADHYAY</td><td>11 D</td></tr>
    <tr><td>5</td><td>CAPTAIN - KATRE HOUSE</td><td>GAUTTAMI VERMA</td><td>11 C</td></tr>
    <tr><td>6</td><td>VICE CAPTAIN – KATRE HOUSE</td><td>RONIT</td><td>11 E</td></tr>
    <tr><td>7</td><td>PREFECT – KATRE HOUSE</td><td>MANVI JHA</td><td>11 B</td></tr>
    <tr><td>8</td><td>PREFECT – KATRE HOUSE</td><td>KAMYA SINGH</td><td>11 C</td></tr>
    <tr><td>9</td><td>CAPTAIN - LATIF HOUSE</td><td>P NIRMALA</td><td>11 B</td></tr>
    <tr><td>10</td><td>VICE CAPTAIN – LATIF HOUSE</td><td>MANASVI</td><td>11 D</td></tr>
    <tr><td>11</td><td>PREFECT – LATIF HOUSE</td><td>ANSH CHANDRASHEKHAR HIREMATH</td><td>11 E</td></tr>
    <tr><td>12</td><td>PREFECT – LATIF HOUSE</td><td>ADVITA U MENON</td><td>11 C</td></tr>
    <tr><td>13</td><td>CAPTAIN - PRATAP HOUSE</td><td>TANISHQ PRIYAM</td><td>11 D</td></tr>
    <tr><td>14</td><td>VICE CAPTAIN – PRATAP HOUSE</td><td>RABANI SINGH</td><td>11 B</td></tr>
    <tr><td>15</td><td>PREFECT – PRATAP HOUSE</td><td>DARPINDER KAUR</td><td>11 B</td></tr>
    <tr><td>16</td><td>PREFECT – PRATAP HOUSE</td><td>ABHYA SINGH</td><td>11 B</td></tr>
    <tr><td>17</td><td>CAPTAIN - SUBROTO HOUSE</td><td>AAENA TIWARI</td><td>11 E</td></tr>
    <tr><td>18</td><td>VICE CAPTAIN – SUBROTO HOUSE</td><td>REYANSH KATYAL</td><td>11 E</td></tr>
    <tr><td>19</td><td>PREFECT – SUBROTO HOUSE</td><td>ALOVERA</td><td>11 E</td></tr>
    <tr><td>20</td><td>PREFECT – SUBROTO HOUSE</td><td>RIDDHIMAN SANTRA</td><td>11 D</td></tr>
    <tr><td>21</td><td>HEAD ACADEMICS</td><td>DIVYJYOTI HANDA</td><td>11 B</td></tr>
    <tr><td>22</td><td>PREFECT ACADEMICS</td><td>VYAAN ARORA</td><td>11 E</td></tr>
    <tr><td>23</td><td>PREFECT ACADEMICS</td><td>AARUSH CHAURASIA</td><td>11 E</td></tr>
    <tr><td>24</td><td>HEAD CO-CURRICULAR</td><td>AADYA UPADHYAY</td><td>11 A</td></tr>
    <tr><td>25</td><td>PREFECT CO-CURRICULAR</td><td>KUSHAGGRA TANOTRA</td><td>11 C</td></tr>
    <tr><td>26</td><td>PREFECT CO-CURRICULAR</td><td>PRAKHAR</td><td>11 A</td></tr>
    <tr><td>27</td><td>HEAD DISCIPLINE (BOYS)</td><td>AHAAN VERMA</td><td>11 D</td></tr>
    <tr><td>28</td><td>HEAD DISCIPLINE (GIRLS)</td><td>RIDHIMAA TRIPATHI</td><td>11 E</td></tr>
    <tr><td>29</td><td>PREFECT DISCIPLINE</td><td>JASHANBIR SINGH PURI</td><td>11 E</td></tr>
    <tr><td>30</td><td>PREFECT DISCIPLINE</td><td>SAMRAT KALONIA</td><td>11 E</td></tr>
    <tr><td>31</td><td>PREFECT DISCIPLINE (SP. CHILD)</td><td>AADIYA SRI DAS</td><td>11 A</td></tr>
    <tr><td>32</td><td>SPORTS CAPTAIN (BOYS)</td><td>ARNAB KASHYAP</td><td>11 C</td></tr>
    <tr><td>33</td><td>SPORTS CAPTAIN (GIRLS)</td><td>GAURI SHARMA</td><td>11 E</td></tr>
    <tr><td>34</td><td>SPORTS PREFECT</td><td>ABHINAV NAUTIYAL</td><td>11 E</td></tr>
    <tr><td>35</td><td>SPORTS PREFECT</td><td>ACHINTYA PRATAP SINGH</td><td>11 E</td></tr>
    <tr><td>36</td><td>HEAD JOURNALISM</td><td>SIFFAT KAUR</td><td>11 A</td></tr>
    <tr><td>37</td><td>VICE HEAD JOURNALISM</td><td>ALANA AMEEN</td><td>11 B</td></tr>
    <tr><td>38</td><td>PREFECT JOURNALISM</td><td>ADARSH</td><td>11 A</td></tr>
    <tr><td>39</td><td>PREFECT JOURNALISM</td><td>ADITI SHARMA</td><td>11 E</td></tr>
    <tr><td>40</td><td>HEAD GIRL</td><td>LIZA ZAIDI</td><td>11 A</td></tr>
    <tr><td>41</td><td>HEAD BOY</td><td>SHAURYA TYAGI</td><td>11 E</td></tr>
    <tr><td>42</td><td>VICE HEAD GIRL</td><td>ANESHKAA ELAMURUGU</td><td>11 B</td></tr>
    <tr><td>43</td><td>VICE HEAD BOY</td><td>AARAV DIXIT</td><td>11 E</td></tr>
    <tr><td>44</td><td>BOARDING HOUSE CAPTAIN</td><td>DIVY SHARMA</td><td>11 A</td></tr>
                   </tbody>
                 </table>
        </div>
         
                </div>
            </div>
            </div>
        </div>
     </>
  )
}

export default SeniorBoard